import React from "react";

const PastStays = ({ stays }) => {
  if (!stays) {
    return (
      <div className=" w-100 d-flex justify-content-center align-items-center fw-semibold mt-2">
        No data available{" "}
      </div>
    );
  }

  return (<>
    {stays.map((stay) => {
      return (<div className="card shadow-sm p-4 w-100">
        <h5 className="mb-4 text-primary">Past Stay Details</h5>
        <div className="row mb-3">
          <div className="col-md-6 mb-3">
            <strong>Booking Reference:</strong>
            <div>{stay?.booking_id}</div>
          </div>
          <div className="col-md-6 mb-3">
            <strong>Booking Type:</strong>
            <div>{stay?.booking_type}</div>
          </div>
          <div className="col-md-6 mb-3">
            <strong>Check-in:</strong>
            <div>
              {new Date(stay?.check_in_date_time).toLocaleString()}
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <strong>Check-out:</strong>
            <div>
              {new Date(stay?.check_out_date_time).toLocaleString()}
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <strong>Additional Guests:</strong>
            <div>{stay?.additional_guests.length}</div>
          </div>
          <div className="col-md-6 mb-3">
            <strong>Room Numbers:</strong>
            <div>
              {stay?.enrichedRooms && stay.enrichedRooms.length > 0 ? (
                stay.enrichedRooms.map((room, index) => (
                  <span key={room.room_id}>
                    {room.room_number}
                    {index !== stay.enrichedRooms.length - 1 && ", "}
                  </span>
                ))
              ) : (
                <span>N/A</span>
              )}
            </div>        </div>
          <div className="col-md-6">
            <strong>Remarks:</strong>
            <div>{stay?.remarks}</div>
          </div>
          {stay?.cancelled_at && <div className="col-md-6">
            <strong>Booking Cancelled:</strong>
            <div>{new Date(stay?.cancelled_at).toLocaleString()}</div>
          </div>}
        </div>
      </div>)
    })}
  </>
  );
};

export default PastStays;
